import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme, varianttype, fontSize, fontWeight, ogsize, sizebutton, fullWidth }) => {
    const fixedWidthStyles = [
        { name: "icon", width: "42px !important" },
        { name: "s", width: "132px" },
        { name: "m", width: "154px" },
        { name: "l", width: "198px" },
        { name: "xl", width: "254px" },
        { name: "auto", width: "auto" },
    ];

    const common = {
        fontWeight: fontWeight || 600,
        borderRadius: 6,
        height: ogsize === "small" || varianttype === "primaryText" || varianttype === "errorText" ? "inherit" : 42,
        fontSize: fontSize || 14,
        whiteSpace: "nowrap",
        width: !fullWidth ? fixedWidthStyles.find((item) => item.name === (sizebutton ?? "auto")).width : "100%",
        minWidth: !fullWidth ? fixedWidthStyles.find((item) => item.name === (sizebutton ?? "auto")).width : "100%",
    };

    switch (varianttype) {
        case "primaryContained":
            return { ...common };
        case "secondaryContainedButton":
            return {
                backgroundColor: theme.palette.secondary.main,
                ...common,
            };
        case "primaryText":
            return { ...common };
        case "errorText":
            return {
                color: theme.palette.secondary.main, // Rosa
                ...common,
            };
        case "primaryOutlined":
            return { color: theme.palette.V003, borderColor: theme.palette.V003, ...common };
        case "primaryTextButton":
            return { ...common };
        case "errorTextButton":
            return {
                color: theme.palette.secondary.main, // Rosa
                ...common,
            };
        default:
            return {};
    }
});

const BaseButton = (props) => {
    const {
        children,
        id,
        onClick,
        size,
        type,
        fullWidth,
        variant,
        className,
        disabled,
        variantType = "primaryContained",
        sx,
        fontSize,
        fontWeight,
        sizebutton,
        anchorRefBtnColumns,
        ...rest
    } = props;

    const fTextSmall = variantType === "primaryText" || variantType === "errorText";
    const fText = fTextSmall || variantType === "primaryTextButton" || variantType === "errorTextButton";
    const fContained = variantType === "primaryContained" || variantType === "secondaryContainedButton";
    const fOutlined = variantType === "primaryOutlined";

    // Si la variante es "primaryText", forzar el tipo de variante a "text"
    const computedVariant = fText ? "text" : fContained ? "contained" : fOutlined ? "outlined" : variant;
    const computedSize = fTextSmall ? "small" : size;

    return (
        <StyledButton
            id={id}
            onClick={onClick}
            size={computedSize}
            type={type}
            fullWidth={fullWidth}
            variant={computedVariant}
            className={className}
            disabled={disabled}
            varianttype={variantType}
            fontSize={fontSize}
            fontWeight={fontWeight}
            ogsize={size}
            sx={sx}
            sizebutton={sizebutton}
            ref={anchorRefBtnColumns}
            {...rest}
        >
            {children}
        </StyledButton>
    );
};

export default BaseButton;
